import React, { FC } from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";

///// Interface for alert dialog props
interface AlertDialogProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  title?: string;
  description?: string;
  onConfirm?: () => void;
  onClose?: () => void;
  showCancelButton?: boolean;
}
//// alert dialog comman components
const AlertDialog: FC<AlertDialogProps> = ({
  open,
  setOpen,
  title,
  description,
  onConfirm,
  onClose,
  showCancelButton,
}) => {
  //// close the alert dialog
  const handleClose = () => {
    if (onClose) {
      onClose();
    }
    setOpen(false);
  };

  //// handle confirm code
  const handleConfirm = () => {
    if (onConfirm) {
      onConfirm();
    }
    setOpen(false);
  };

  // Function to render description content based on whether it contains newline characters
  const renderDescription = () => {
    if (description && description.includes("\n")) {
      return description
        .split("\n")
        .map((line, index) => <p key={index}>{line}</p>);
    } else {
      return <p>{description}</p>;
    }
  };

  return (
    <Dialog
      open={open}
      onClose={(_, reason) => {
        if (reason !== "backdropClick" && reason !== "escapeKeyDown") {
          handleClose();
        }
      }}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      disableEscapeKeyDown
    >
      <DialogTitle id="alert-dialog-title">{title || ""}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {renderDescription()}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        {showCancelButton && <Button onClick={handleClose}>Cancel</Button>}
        <Button onClick={handleConfirm} autoFocus>
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AlertDialog;
